import { ApolloLink } from '@apollo/client/core'

// The actual max that is causing issues is 2000 chars for us as this is the standard length where
// browsers start to make a fuzz https://stackoverflow.com/a/417184 but it can be anything in the
// entire pipline including stuff like CDN's or even cloudflare. So reducing it to 1900 as our max
// is done to allow for additional parameters that might be added outside of apollo.
const MAX_URL_LENGTH = 1900

// This link will check if the request URI is longer than the max length and if so it will change the method to POST
// Used in conjunction with the Persistent queries to handle large payloads
export const HandleLongGETRequestURIs = new ApolloLink((operation, forward) => {
  const { uri, fetchOptions } = operation.getContext()

  // If it is already a post method we skip, we will only check get requests for our length limit
  if (fetchOptions?.method !== 'GET') return forward(operation)

  const variables = operation.variables ?? {}
  const extensions = operation.extensions ?? {}
  const opName = operation.operationName ?? ''

  const params = new URLSearchParams()
  if (opName) params.set('operationName', opName)
  if (Object.keys(variables).length) params.set('variables', JSON.stringify(variables))
  if (Object.keys(extensions).length) params.set('extensions', JSON.stringify(extensions))

  const potentialUrl = `${uri}?${params.toString()}`

  operation.setContext(() => ({
    fetchOptions: {
      ...fetchOptions,
      method: potentialUrl.length > MAX_URL_LENGTH ? 'POST' : 'GET',
    },
  }))

  return forward(operation)
})
